import angular from 'angular';

import PrivilegeTemplateSaveConfirmationDialogComponent from './privilege-template-save-confirmation-dialog-component';

export default angular
  .module('privilege-template-save-confirmation-dialog', [])
  .component('privilegeTemplateSaveConfirmationDialog', new PrivilegeTemplateSaveConfirmationDialogComponent());



// WEBPACK FOOTER //
// ./src/modules/privilege-templates/components/privilege-template-save-confirmation-dialog/privilege-template-save-confirmation-dialog-module.js